import { ApiResponse } from '@/models/api'
import client from './index'

import { CreateEvAdminAccount, EvAdmin } from '@/models/evAdmin'

export default {
  usersList() {
    return client.get<ApiResponse<EvAdmin[]>>('/ev-admins')
  },

  // inviteUser(params: CreateEvAdminAccount) {
  //   return client.post<ApiResponse<null>>('/ev-admins', params)
  // },
  inviteUser(params: CreateEvAdminAccount) {
    return client.post<ApiResponse<null>>('/ev-admins', params)
  },

  updateUserStatus(id: string, params: Pick<EvAdmin, 'ev_role' | 'ev_status'>) {
    return client.put<ApiResponse<EvAdmin>>(`/ev-admins/${id}`, params)
  },

  carOwnersList() {
    return client.get<ApiResponse<EvAdmin[]>>('/ev-admins/car-owners')
  },
}
